/* eslint-disable */
export default {
  unknown: '未知',
  anonymous: '匿名',
  activeCalls: '所有通話',
} as const;

// @key: @#@"unknown"@#@ @source: @#@"Unknown"@#@
// @key: @#@"anonymous"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"activeCalls"@#@ @source: @#@"All Calls"@#@
